var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,3.93a4.12,4.12,0,0,1-.29,1.5,3.8,3.8,0,0,1-.86,1.28L7.42,22.15,0,24l1.85-7.42L17.29,1.15A3.8,3.8,0,0,1,18.57.29,4.12,4.12,0,0,1,20.07,0,3.77,3.77,0,0,1,21.6.31a4.29,4.29,0,0,1,1.25.84,4.29,4.29,0,0,1,.84,1.25A3.77,3.77,0,0,1,24,3.93Zm-21.94,18,3.86-1a4,4,0,0,0-.38-1,3.93,3.93,0,0,0-.64-.86,3.93,3.93,0,0,0-.9-.61,4,4,0,0,0-1-.38Zm1.76-5.21a5.36,5.36,0,0,1,3.45,3.45L19.93,7.5,16.5,4.07ZM21,6.43l.56-.55A4,4,0,0,0,22,5.34a2.87,2.87,0,0,0,.34-.62,2.37,2.37,0,0,0,.12-.78A2.34,2.34,0,0,0,22.31,3,2.57,2.57,0,0,0,21,1.69a2.34,2.34,0,0,0-1-.19,2.37,2.37,0,0,0-.78.12,2.87,2.87,0,0,0-.62.34,4,4,0,0,0-.54.48L17.57,3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-Icon.fde99f31.svg";
export { ForwardRef as ReactComponent };